import Login from './views/Login.vue'
import LoginForm from './components/LoginForm.vue'
import NotFound from './views/404.vue'
import Home from './views/Home.vue'
import changPwd from './views/changpwd.vue'
import VueRouter from 'vue-router'

//解决路由报错相同路由跳转问题 start Navigation cancelled from "xxx" to "xxx" with a new navigation
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;

VueRouter.prototype.push = function push(location, onResolve, onReject) {
    return originalPush.call(this, location).catch(err => err);
};

VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
    return originalReplace.call(this, location).catch(err => err);
};
//解决路由报错相同路由跳转问题 end

let routes = [
    {
        path: '/',
        component: LoginForm,
        redirect: '/loginForm',
        name: '',
        hidden: true
    },
    {
        path: '/changpwd',
        component: changPwd,
        name: '',
        hidden: true
    },
    {
        path: '/loginForm',
        component: LoginForm,
        name: '',
        hidden: true
    },
    {
        path: '/404',
        component: NotFound,
        name: '',
        hidden: true
    },
    {
        path: '/home',
        component: Home,
        redirect: '/index',
        name: '首页',
        iconCls: 'el-icon-message', //图标样式class
        children: [
            {path: '/index', component: resolve => require(['./components/index.vue'], resolve), name: '首页'}
        ]
    },
    {
        path: '/home',
        component: Home,
        name: '理赔管理',
        iconCls: 'fa fa-bar-chart',
        children: [
            {
                path: '/claimQuery',
                component: resolve => require(['./components/claimManager/claimQuery.vue'], resolve),
                name: '理赔查询'
            },
            {
                path: '/claimAdd',
                component: resolve => require(['./components/claimManager/claimAdd.vue'], resolve),
                name: '新增案件'
            },
            {
                path: '/unfinishedClaim',
                component: resolve => require(['./components/claimManager/unfinishedClaim.vue'], resolve),
                name: '未决案件'
            },
            {
                path: '/finishedClaim',
                component: resolve => require(['./components/claimManager/finishedClaim.vue'], resolve),
                name: '已决案件'
            },
            {
                path: '/returnListPage',
                component: resolve => require(['./components/claimManager/returnListPage.vue'], resolve),
                name: '理赔回访'
            },
            // {path:'/claimDetail', component:resolve => require(['./components/claimManager/claimDetail.vue'], resolve), name:'案件详情'},
            // {path:'/cliamhi', component:resolve => require(['./components/claimManager/claimHis.vue'], resolve), name:'案件详情'},
            // {path:'/claimDetail/:policyNo', component:resolve => require(['./components/claimManager/claimDetail.vue'], resolve), props: true, name:'案件详情'},
        ]
    },
    {
        path: '/home',
        component: Home,
        name: '资料',
        iconCls: 'fa fa-bar-chart',
        children: [
            {
                path: '/answerManager',
                component: resolve => require(['./components/dataRoom/answerManager.vue'], resolve),
                name: '疑问解答'
            },
            {
                path: '/caseList',
                component: resolve => require(['./components/dataRoom/caseList.vue'], resolve),
                name: '相关案例'
            },
            {
                path: '/companyStandard',
                component: resolve => require(['./components/dataRoom/notice/companyStandard.vue'], resolve),
                name: '公司规范'
            },
            {
                path: '/companyStandardTemp',
                component: resolve => require(['./components/dataRoom/notice/companyStandardList.vue'], resolve),
                name: '公司规范模板'
            },
            {
                path: '/personnelNotice',
                component: resolve => require(['./components/dataRoom/notice/personnelNotice.vue'], resolve),
                name: '人事通知'
            },
        ]
    },
    {
        path: '/home',
        component: Home,
        name: '资料管理',
        iconCls: 'fa fa-bar-chart',
        children: [
            {
                path: '/problemManager',
                component: resolve => require(['./components/dataRoom/problemManager.vue'], resolve),
                name: '问题管理'
            },
            {
                path: '/caseManager',
                component: resolve => require(['./components/dataRoom/caseManager.vue'], resolve),
                name: '案例管理'
            },
            {
                path: '/companyStandardManager',
                component: resolve => require(['./components/systemManager/noticeManager/noticeManager.vue'], resolve),
                name: '公司规范管理'
            },

            {
                path: '/personnelNoticeManager',
                component: resolve => require(['./components/systemManager/noticeManager/personnelNoticeManager.vue'], resolve),
                name: '人事通知管理'
            },
        ]
    },
    {
        path: '/home',
        component: Home,
        name: '系统管理',
        iconCls: 'fa fa-bar-chart',
        children: [
            {
                path: '/menuManager',
                component: resolve => require(['./components/systemManager/menuManager.vue'], resolve),
                name: '菜单管理'
            },
            {
                path: '/buttonManager',
                component: resolve => require(['./components/systemManager/buttonManager.vue'], resolve),
                name: '按钮管理'
            },
            {
                path: '/roleManager',
                component: resolve => require(['./components/systemManager/roleManager.vue'], resolve),
                name: '角色管理'
            },
            {
                path: '/userManager',
                component: resolve => require(['./components/systemManager/userManager.vue'], resolve),
                name: '系统管理-客户列表'
            },
            {
                path: '/permissionManager',
                component: resolve => require(['./components/systemManager/permissionManager.vue'], resolve),
                name: '权限管理'
            },
            {
                path: '/paramManager',
                component: resolve => require(['./components/systemManager/paramManager.vue'], resolve),
                name: '参数管理'
            },
            {
                path: '/buttonManager',
                component: resolve => require(['./components/systemManager/buttonManager.vue'], resolve),
                name: '按钮管理'
            },
        ]
    },
    {
        path: '/home',
        component: Home,
        name: '保单系统管理',
        iconCls: 'fa fa-bar-chart',
        children: [
            {
                path: '/warrantyAdd',
                component: resolve => require(['./components/warrantyManager/warrantyAdd.vue'], resolve),
                name: '新增保单'
            },
            {
                path: '/warrantySearch',
                component: resolve => require(['./components/warrantyManager/warrantySearch.vue'], resolve),
                name: '保单查询'
            },
            {
                path: '/tempWarrantySearch',
                component: resolve => require(['./components/warrantyManager/TempWarrantySearch.vue'], resolve),
                name: '暂存保单'
            },
            {
                path: '/lossWarrantySearch',
                component: resolve => require(['./components/warrantyManager/lossWarrantySearch.vue'], resolve),
                name: '注销保单'
            },
            {
                path: '/warrantyAuditing',
                component: resolve => require(['./components/warrantyManager/warrantyAuditing.vue'], resolve),
                name: '审核保单'
            },
            {
                path: '/warrantDetail',
                component: resolve => require(['./components/warrantyManager/warrantDetail.vue'], resolve),
                name: '保单详情'
            },

        ]
    },
    {
        path: '/home',
        component: Home,
        name: '询价管理',
        iconCls: 'fa fa-bar-chart',
        children: [
            {
                path: '/enquiryAdd',
                component: resolve => require(['./components/enquiryManager/enquiryAdd.vue'], resolve),
                name: '添加询价'
            },
            {
                path: '/enquiryListhby',
                component: resolve => require(['./components/enquiryManager/enquiryListhby.vue'], resolve),
                name: '询价列表-承保人'
            },
            {
                path: '/enquiryListhbjl',
                component: resolve => require(['./components/enquiryManager/enquiryListhbjl.vue'], resolve),
                name: '询价列表-承保经理'
            },
            {
                path: '/enquiryRejectList',
                component: resolve => require(['./components/enquiryManager/enquiryRejectList.vue'], resolve),
                name: '询价丢失列表'
            },

        ]
    },
    {
        path: '/home',
        component: Home,
        name: '续保管理',
        iconCls: 'fa fa-bar-chart',
        children: [
            {
                path: '/renewalPolicyList',
                component: resolve => require(['./components/renewalPolicyManager/renewalPolicyList.vue'], resolve),
                name: '续保清单'
            },
            {
                path: '/renewalPolicyDelList',
                component: resolve => require(['./components/renewalPolicyManager/renewalPolicyDelList.vue'], resolve),
                name: '续保丢失'
            },
        ]
    },
    {
        path: '/home',
        component: Home,
        name: '出单管理',
        iconCls: 'fa fa-bar-chart',
        children: [
            {
                path: '/SingleList',
                component: resolve => require(['./components/SingleManager/SingleList.vue'], resolve),
                name: '出单列表'
            },

        ]
    },
    {
        path: '/home',
        component: Home,
        name: '财务管理',
        iconCls: 'fa fa-bar-chart',
        children: [
            {
                path: '/InvoiceList',
                component: resolve => require(['./components/financialManager/InvoiceManager/InvoiceList.vue'], resolve),
                name: '开票管理'
            },
            {
                path: '/PaymentManager',
                component: resolve => require(['./components/financialManager/PaymentManager.vue'], resolve),
                name: '支付管理'
            },
            {
                path: '/normalCollection',
                component: resolve => require(['./components/financialManager/normalCollection.vue'], resolve),
                name: '正常保费催收管理'
            },
            {
                path: '/postponeCollection',
                component: resolve => require(['./components/financialManager/postponeCollection.vue'], resolve),
                name: '延期保费催收管理'
            },
            {
                path: '/warrantyMannger',
                component: resolve => require(['./components/warrantyManager/warrantySearch.vue'], resolve),
                name: '保单管理'
            },
            {
                path: '/insuranceCompany',
                component: resolve => require(['./components/financialManager/insuranceCompany.vue'], resolve),
                name: '保险公司管理'
            },
            {
                path: '/unpaidCollection',
                component: resolve => require(['./components/financialManager/unpaidCollection.vue'], resolve),
                name: '出单保费催收'
            },
            {
                path: '/insuranceCombination',
                component: resolve => require(['./components/enquiryManager/insuranceCombination.vue'], resolve),
                name: '共保组合'
            },
        ]
    },
    {
        path: '/home',
        component: Home,
        name: '国外财务管理',
        iconCls: 'fa fa-bar-chart',
        children: [
            {
                path: '/normalCollectionForeign',
                component: resolve => require(['./components/financialManager/normalCollectionForeign.vue'], resolve),
                name: '正常保费催收管理-外'
            },
            {
                path: '/InvoiceListForeign',
                component: resolve => require(['./components/financialManager/InvoiceManager/InvoiceListForeign.vue'], resolve),
                name: '经纪费结算管理-外'
            },
            {
                path: '/postponeCollectionForeign',
                component: resolve => require(['./components/financialManager/postponeCollectionForeign.vue'], resolve),
                name: '延期保费催收管理-外'
            },
            {
                path: '/PaymentManagerForeign',
                component: resolve => require(['./components/financialManager/PaymentManagerForeign.vue'], resolve),
                name: '支付管理-外'
            },
        ]
    },
    {
        path: '/home',
        component: Home,
        name: 'CRM系统',
        iconCls: 'fa fa-bar-chart',
        children: [
            {
                path: '/usermanngerList',
                component: resolve => require(['./components/crmMannger/usermanngerList.vue'], resolve),
                name: 'CRM系统-客户列表'
            },
            {
                path: '/userMangerStateList',
                component: resolve => require(['./components/crmMannger/userMangerStateList.vue'], resolve),
                name: 'CRM系统-客户状态'
            },
            {path:'/Cooperative', component:resolve => require(['./components/crmMannger/Cooperative.vue'], resolve), name:'已合作详情'},
            {path:'/noCooperation', component:resolve => require(['./components/crmMannger/noCooperation.vue'], resolve), name:'未合作详情'}
        ]
    },
    {
        path: '/home',
        component: Home,
        name: '客户管理',
        iconCls: 'fa fa-bar-chart',
        children: [
            {
                path: '/userList',
                component: resolve => require(['./components/userMannger/userList.vue'], resolve),
                name: '客户管理-列表'
            },
            {
                path: '/managerCooperative',
                component: resolve => require(['./components/userMannger/managerCooperative.vue'], resolve),
                name: '客户列表-已合作详情'
            },
            {
                path: '/managerNocooperative',
                component: resolve => require(['./components/userMannger/managerNocooperative.vue'], resolve),
                name: '客户列表-未合作详情'
            }
        ]
    },
    // {
    //   path:'*',
    //     hidden:true,
    //     redirect: {path:'/404'}
    // }
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js